import { getSessionStorage } from '/@/utils/storage'
export default (to, from, next) => {
  if (to.meta && !to.meta.needLogin) {
    next()
  } else {
    const token = getSessionStorage('token')
    if (token) {
      next()
    } else if (to.path === '/login') {
      next()
    } else {
      next({
        path: '/login'
        // query: { redirect: to.fullPath }
      })
    }
  }
}
